import React from "react"
import { motion } from 'framer-motion'
import ContactUsImg from '../../Assets/Images/Mention-rafiki.svg'

const ContactUs = () => {
    return (
        <motion.div className={`relative w-full flex flex-col h-full items-center justify-center`}>
            <motion.div className={`w-3/4 flex flex-row h-screen drop-shadow-md bg-white`}>
                <motion.div className={`w-1/4 h-full`}>
                    <img src={ContactUsImg} height={100} />
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default ContactUs